import axios from "axios";

export function handleAxiosError(error: unknown): never {
  if (axios.isAxiosError(error) && error.response) {
    const status = error.response.status;
    if (status >= 400 && status < 500) {
      throw new Error(
        JSON.stringify({
          message: error.message,
          code: error.code
        })
      );
    }
  }

  if (error instanceof Error) {
    throw new Error(error.message);
  }

  throw new Error("Bad Request");
}
